import Util from '../utils/util.js';
import { reinitializeSelect2 } from '../utils/forms.js';
import { webformIsDisabled } from '../utils/webform.js';
import { preserveUnsavedState } from '../utils/beforeunload.js';

/**********************************************************
 * Background Module
 **********************************************************/

if (window.site_type && window.site_type === 'epscor') {

function onReadyModuleBackground() {
    let j_months_worked = $('#months_worked');
    if (j_months_worked.length && !j_months_worked.prop('disabled') /* don't do anything if form is disabled (submitted) */) {
        j_months_worked.change(function() {
            let j_over_160 = $('#hours_worked_over_160');
            if (j_months_worked.val() >= 2) {
                $('#hours_worked_over_160_hidden').remove();
                j_over_160.val('Yes');
                j_over_160.prop('disabled', true);
                // Add a hidden element so it submits, as disabled inputs do not submit
                j_over_160.after('<div id="hours_worked_over_160_hidden"><input type="hidden" name="hours_worked_over_160" value="Yes">' +
                    '<div style="margin-bottom:0" class="alert alert-info">This field has been set to "Yes" since you selected 2 or more months worked.</div></div>')
            } else {
                j_over_160.prop('disabled', false);
                $('#hours_worked_over_160_hidden').remove();
            }
        });
        j_months_worked.change();
    }

    if (!$('#is_participant').val()) {
        $(
            'option[value="background_project_role----graduate_student_research_assistant"],' +
            'option[value="background_project_role----undergraduate_student"],' +
            'option[value="background_project_role----technical_school_student"],' +
            'option[value="background_project_role----high_school_student"],' +
            'option[value="background_project_role----reu_participant"]', '#project_role').remove();
    }

    let j_graduation_section = $('.webform_element_graduation_semester');
    $('#role').change(function() {
        if ($.inArray($(this).val(), [
                'background_project_role----graduate_student_research_assistant',
                'background_project_role----undergraduate_student',
                'background_project_role----technical_school_student',
                'background_project_role----high_school_student',
                'background_project_role----reu_participant']) == -1) {
            j_graduation_section.hide();
        } else {
            j_graduation_section.show();
        }
    });
    $('#role').change();
}

/**********************************************************
 * Participants Module
 **********************************************************/

function onReadyModuleParticipants() {
    $('td.webform_table_element_created_in_reporting_period_id').each(function() {
        let created_in_rp_id = $(this).html();
        if (created_in_rp_id != current_rp_id) {
            $(this).parent('tr').find('input[value="Delete"]').parent('td').html(
                '<span ' +
                'class="is-tooltip btn btn-default btn-xs" ' +
                'data-toggle="tooltip" ' +
                'title="This participant was<br>imported from a<br>prior reporting period" ' +
                '>' +
                'Imported</span>');
        }
    });
    $(".is-tooltip").tooltip({
        placement: 'left',
        viewport: 'table.webform_multiple',
        html: true
    });
    $('.webform_table_element_created_in_reporting_period_id').remove();

    let needsUpdatedCount = 0;
    $('td.webform_table_element_is_draft').each(function() {
        let is_draft = $(this).html();
        if (is_draft == 0) {
            $(this).html('<span class="glyphicon glyphicon-ok text-success center-block"></span>');
        } else {
            $(this).html('Must Update');
            needsUpdatedCount++;
        }
    });
    if (needsUpdatedCount) {
        $('#_webform_action\\[submit_all\\]').prop('disabled', true);
        $('#complete_instructions').html(
            'You cannot complete this module until you have updated all participants from the initial reporting period.'
        );
    }
}

function onReadyModuleParticipantsSubform() {
    if (webformIsDisabled()) {
        $('#search_participants').remove();
        return;
    }

    // Warn about deleting funding record
    if ($('#has_funding').val()) {
        $('#funding').change(function() {
            $('#funded_alert').remove();
            if (!($(this).val() == 'participants_funding----fully_funded' || $(this).val() == 'participants_funding----partially_funded')) {
                $(this).after('<div id="funded_alert" class="alert alert-danger">Saving this selection will delete the funding record for this participant.</div>')
            }
        });
        $('#is_active_this_year').change(function() {
            $('#inactive_funded_alert').remove();
            if ($(this).val() != 1) {
                $(this).after('<div id="inactive_funded_alert" class="alert alert-danger">Saving this selection will delete the funding record for this participant.</div>')
            }
        });
        // Turn email into a hidden field
        $('#email').prop('disabled', true).after(
            '<input type=hidden name=email value="' + $('#email').val() + '">' +
            '<div id="email-disabled" style="margin-bottom:0" class="alert alert-info">' +
            'You cannot change the email address of this participant, since funding ' +
            'information has already been entered for them.</div>');
    } else if (!$('#email').prop('disabled')) {
        $('#email').prop('disabled', false);
    }

    // Handle search
    let id = $('.webform input[name="id"]').val();
    if (id) {
        $('#search-section').removeClass('in');
    } else {
        $('#search-section').addClass('in');
    }

    $('#search_participants').typeahead({}, {
        name: 'search_participants',
        displayKey: 'name',
        source: function(query, sync, async) {
            query = Util.urlEncode(query);
            //Check for blank queries.
            if (query != '') {
                $.ajax(window['public_path'] + '/participants/search/' + query, {dataType: 'json'})
                    .success(function (result) {
                        async(result);
                    });
            }
        },
        templates: {
            suggestion: function (t) {
                return '<div><div class="name">'+(t.name||'')+'</div><div class="email">'+(t.email||'')+'</div></div>';
            }
        }
    }).on('typeahead:select typeahead:autocomplete', function($e, datum) {
        Util.setFromJson(datum);
    });

    // Show message if in edit mode and there is no delet button showing
    let isEdit = window['route_id'];
    if (isEdit && ! $('.webform-delete').length) {
        $('.webform_element_type_actions > div').append(
            '<div class="alert alert-info" style="margin-top:10px">' +
            'You may not delete this participant since they already have a user account. ' +
            'Please mark them as not having Worked on Project or Not Needing to Report instead if desired.</div>');
    }
    if (!$('#user_account_id').val()) { // For users who don't yet have a user account
        $('#email').change(function()
        {
            let email = $(this).val();

            if (!email) {
                return;
            }

            $.ajax(window['public_path'] + '/user/exists/' + email)
             .success(function(result)
             {
                 if (result) { // only show welcome field if user doesn't exist
                     $('.webform_element_send_welcome_on_save').addClass('hidden');
                 } else {
                     $('.webform_element_send_welcome_on_save').removeClass('hidden');
                 }
             });
        }).change();
    }
}

///**********************************************************
// * Funding Module
// **********************************************************/
//
//function fundingShowHidePrograms(event) {
//    let section = event.data.section;
//    if ($("#has_" + section).val() == 1 &&
//        ($("#" + section + "_supported_months_summer").val() > 0 ||
//        $("#" + section + "_supported_months_year").val() > 0 ||
//        $("#" + section + "_funding_amount").val().replace(/[^0-9]/, '') > 0) // Convert to int (strip commas, $, etc)
//    ) {
//        $("#" + section + "_funding_sources").parents('.form-group').addClass('in');
//    } else {
//        $("#" + section + "_funding_sources").parents('.form-group').removeClass('in');
//        Util.setupLabelPositionAdjuster();
//    }
//}
//
//function onReadyModuleFunding() {
//    $(
//        '#has_other_nsf,' +
//        '#other_nsf_supported_months_summer,' +
//        '#other_nsf_supported_months_year'
//    ).change({section: 'other_nsf'}, fundingShowHidePrograms).change(); // fire change event
//    $(
//        '#has_government,' +
//        '#government_supported_months_summer,' +
//        '#government_supported_months_year'
//    ).change({section: 'government'}, fundingShowHidePrograms).change(); // fire change event
//    $(
//        '#has_non_university,' +
//        '#non_university_supported_months_summer,' +
//        '#non_university_supported_months_year'
//    ).change({section: 'non_university'}, fundingShowHidePrograms).change(); // fire change event
//
//    // Add keyUp handlers to show the "Other Sources" textarea immediately when an amount is entered
//    $('#other_nsf_funding_amount').keyup({section: 'other_nsf'}, fundingShowHidePrograms);
//    $('#government_funding_amount').keyup({section: 'government'}, fundingShowHidePrograms);
//    $('#non_university_funding_amount').keyup({section: 'non_university'}, fundingShowHidePrograms);
//}

/**********************************************************
 * Publications Module
 **********************************************************/

function publicationArrangeFields(type)
{
    if (type == 'book_chapter') {
        $('#first_page_or_elocation_id').parents('.form-group').insertBefore($('#book_edition').parents('.form-group'));
    } else {
        $('#first_page_or_elocation_id').parents('.form-group').insertBefore($('#publication_date').parents('.form-group'));
    }
    if ($.inArray(type,['conference_paper_or_proceeding','presentation','other']) !== -1) {
        $('#publication_date').parents('.form-group').insertBefore($('#status').parents('.form-group'));
    } else {
        $('#publication_date').parents('.form-group').insertBefore($('#publication_location').parents('.form-group'));
    }
}

function publicationModifyFields(type)
{
    // Set legend
    switch (type) {
        case "journal_article":
            $('.webform legend').first().text('NSF requires individual reporting of the following journal article components:');
            break;
        case "book":
            $('.webform legend').first().text('NSF requires individual reporting of the following book components:');
            break;
        case "book_chapter":
            $('.webform legend').first().text('NSF requires individual reporting of the following book chapter components:');
            break;
        case "thesis_or_dissertation":
            $('.webform legend').first().text('NSF requires individual reporting of the following thesis or dissertation components:');
            break;
        case "conference_paper_or_proceeding":
            $('.webform legend').first().text('NSF requires individual reporting of the following conference paper/proceeding components:');
            break;
        case "presentation":
            $('.webform legend').first().text('NSF requires individual reporting of the following presentation components:');
            break;
        default:
            $('.webform legend').first().text('NSF requires individual reporting of the following publication components:');
            break;
    }

    // Set title (field #2)
    switch (type) {
        case "journal_article":
            $("label[for='title']").text('Article Title');
            break;
        case "book":
        case "book_chapter":
            $("label[for='title']").text('Book Title');
            break;
        case "conference_paper_or_proceeding":
            $("label[for='title']").text('Paper or Proceeding Title');
            break;
        case "presentation":
            $("label[for='title']").text('Presentation Title');
            break;
        case "other":
            $("label[for='title']").text('Publication Title');
            break;
        default:
            $("label[for='title']").text('Title');
            break;
    }

    // Set authors (field #4)
    switch (type) {
        case "journal_article":
            $("label[for='contactlist']").text('Article Author(s)');
            break;
        case "book_chapter":
            $("label[for='contactlist']").text('Chapter Author(s)');
            break;
        default:
            $("label[for='contactlist']").text('Author(s)');
            break;
    }

    // Set volume (field #13)
    switch (type) {
        case "journal_article":
            $("label[for='volume']").text('Journal Volume');
            break;
        case "book":
        case "book_chapter":
            $("label[for='volume']").text('Book Volume');
            $(".webform_element_volume .help-block").text('The book volume number, if applicable.').show();
            break;
        default:
            $("label[for='volume']").text('Volume');
            $(".webform_element_volume .help-block").hide();
            break;
    }

    // Set publication_date (field #16) and publication_location (field #18)
    switch (type) {
        case "conference_paper_or_proceeding":
            $("label[for='conference_name']").text('Conference Name');
        case "presentation":
            $("label[for='conference_name']").text('Conference Name');
            $("label[for='publication_date']").text('Conference Date');
            $("label[for='publication_location']").text('Conference Location');
            $(".webform_element_publication_location .help-block").text('The city and country where the conference was held.');
            $(".webform_element_publication_date, .webform_element_publication_location").css('display', '').removeClass('show_if_published');
            break;
        case "invited_speaker":
            $("label[for='conference_name']").text('Event Name');
            $("label[for='publication_date']").text('Presentation Date');
            $("label[for='publication_location']").text('Location');
            $(".webform_element_publication_location .help-block").text('The city and country where the conference was held.');
            $(".webform_element_publication_date, .webform_element_publication_location").css('display', '').removeClass('show_if_published');
            break;
        case "poster":
            $("label[for='conference_name']").text('Event Name');
            $("label[for='publication_date']").text('Presentation Date');
            $("label[for='publication_location']").text('Location');
            $(".webform_element_publication_location .help-block").text('The city and country where the conference was held.');
            $(".webform_element_publication_date, .webform_element_publication_location").css('display', '').removeClass('show_if_published');
            break;
        case "other":
            $("label[for='publication_date']").text('Date');
            $(".webform_element_publication_date, .webform_element_publication_location").css('display', '').removeClass('show_if_published');
            break;
        default:
            $("label[for='conference_name']").text('Conference Name');
            $("label[for='publication_date']").text('Publication Date');
            $("label[for='publication_location']").text('Publication Location');
            $(".webform_element_publication_location .help-block").text('The city and country of publication.');
            $(".webform_element_publication_date, .webform_element_publication_location").addClass('show_if_published');
            break;
    }

}

function onReadyModulePublications() {
    let jType = $('#type');
    jType.change(function() {
        publicationArrangeFields(Util.makeBareSlug(jType.val()));
        publicationModifyFields(Util.makeBareSlug(jType.val()));
        Util.setupLabelPositionAdjuster();
    });
    jType.change();
    let jWebform = $('.webform');
    $('.show_if_accepted, .show_if_awaiting, .show_if_published', jWebform).css('display', 'none');
    $('#status').change(function() {
        jWebform
            .addClass('not_published')
            .removeClass('published')
            .removeClass('awaiting')
            .removeClass('accepted');
        switch (Util.makeBareSlug($('#status').val())) {
            case 'published': // published
                jWebform
                    .addClass('published')
                    .removeClass('not_published');
                break;
            case 'awaiting_publication': // awaiting
                jWebform.addClass('awaiting');
                break;
            case 'accepted': // accepted
                jWebform.addClass('accepted');
                break;
            default:
                break;
        }
    }).change();

    $('td.webform_table_element_is_complete').each(function() {
        let is_complete = $(this).html();
        if (is_complete == 1) {
            $(this).html('<span class="glyphicon glyphicon-ok text-success center-block"></span>');
        } else {
            $(this).html('No');
        }
    });

    // Assign completion handles to the designated fields.
    Util.assignCompletion(['title', 'chapter_title'], 'publications')
}

/**********************************************************
 * Intellectual Property Module
 **********************************************************/

function ipModifyFields(type)
{
    // Set title (field #1)
    switch (type) {
        case "patent":
            $("label[for='title']").text('Patent Title');
            break;
        case "invention":
            $("label[for='title']").text('Invention Title');
            break;
        case "license":
            $("label[for='title']").text('License Title');
            break;
        default:
            $("label[for='title']").text('Title');
            break;
    }

    // Set description (field #3)
    switch (type) {
        case "patent":
            $("label[for='description']").text('Patent Abstract');
            break;
        case "invention":
            $("label[for='description']").text('Invention Description');
            break;
        default:
            $("label[for='description']").text('Description');
            break;
    }

    // Set status (field #5)
    switch (type) {
        case "license":
            $("label[for='status']").text('License Status');
            break;
        default:
            $("label[for='status']").text('Status');
            break;
    }
}

function onReadyModuleIP() {
    let jType = $('#type');
    jType.change(function() {
        ipModifyFields(Util.makeBareSlug(jType.val()));
        Util.setupLabelPositionAdjuster();
    });
    jType.change();
    $('#status').change(function() {
        switch (Util.makeBareSlug($('#status').val())) {
            case 'granted': // granted
                $('.webform').removeClass('not_granted');
                break;
            default:
                $('.webform').addClass('not_granted');
                break;
        }
    }).change();

    $('#invention_disclosure').change(function() {
        switch ($('#invention_disclosure').val()) {
            case "1": // disclosure
                $('.webform').removeClass('not_disclosure');
                break;
            default:
                $('.webform').addClass('not_disclosure');
                break;
        }
    }).change();

    // Assign completion handles to the designated fields.
    Util.assignCompletion(['title'], 'ip')
}

/**********************************************************
 * Collaborators Module
 **********************************************************/

function onReadyModuleCollaborators() {
    $('.webform input[name*="collaboration\\["]').change(function() {
        if ($(this).attr('name') == 'collaboration[collaboration----no_collaboration]') {
            $('.webform input[name*="collaboration\\["]').not('input[name*="collaboration\\[collaboration----no_collaboration\\]"]').prop('checked', false);
        } else {
            $('input[name*="collaboration\\[collaboration----no_collaboration\\]"]').prop('checked', false);
        }
    });

    $('.webform_element_collaboration label[for="collaboration\\[collaboration----no_collaboration\\]"]').remove();

    Util.assignCompletion(['organization'], 'collaborators')

}

/**********************************************************
 * Outreach Module
 **********************************************************/

function onReadyModuleOutreach() {
    // Assign completion handles to the designated fields.
    Util.assignCompletion(['activity'], 'outreach');
}

/**********************************************************
 * Proposals Module
 **********************************************************/

function onReadyModuleProposals() {
    // Assign completion handles to the designated fields.
    Util.assignCompletion(['proposal_title'], 'proposals');

    // Recommended for full-proposal enabled only for pre-proposals
    setStatusOptionsForProposalType();
}

function setStatusOptionsForProposalType() {
    $('#proposal_type').change(function() {
        switch (Util.makeBareSlug($(this).val())) {
            case 'pre_proposal': // published
                $('#status option[value="proposals_status----recommended"]').prop('disabled', false);
                break;
            case 'proposal':
                if ($('#status').val() == ('proposals_status----recommended')) {
                    $('#status option').prop('selected', false);
                    $('#status').val('');
                }
                $('#status option[value="proposals_status----recommended"]').prop('disabled', true);
                break;
        }
        reinitializeSelect2($('#status')); // update the changes to the initiatives in the select2
    });
}

/**********************************************************
 * Qualtrics Module
 **********************************************************/

function onReadyModuleQualtrics() {
    let j_qualtrics_link = $('.qualtrics_link').attr('disabled', false);
    j_qualtrics_link.click(function (event) {
        let href = $(event.target).data('href');
        event.preventDefault();
        $.post(window['public_path'] + '/qualtrics/clicked/project/' +
			window['route_project'] + '/rp/' + (window['route_rp'] || '')).always(function() {location.reload();});

        window.open(href, '_blank');
    });

    if (j_qualtrics_link.length && !$('#has_opened_survey').val()) {
        $('.main_content input[value="Mark as Complete"]').prop('disabled', true).val('Please launch the survey to complete this module.');
    }
}

/**********************************************************
 * Common Collaboration Fields
 **********************************************************/

function siteInitiatives(siteSlug)
{
    switch (siteSlug) {
        case 'demoepscor':
            return ['socio_ecological_observatory','socio_ecological_modeling_prediction','decision_support_system','cyberinfrastructure','diversity','outreach'];
        case 'daisy':
            return ['social_dynamics_research_framework', 'changing_subseasonal_seasonal_weather_patterns', 'terrestrial_water_carbon_dynamics', 'variable_marginal_quality_water_supplies', 'sustainable_water_energy_infrastructure'];
        case 'laepscor':
            return ['sd1','sd2','central_user_facility', 'outreach','workforce_development_and_diversity', 'sustainability'];
        case 'idahoepscor':
            return ['modeling', 'sagebrush', 'trout', 'mapping', 'workforce_development', 'diversity'];
    }

    console.error(`Please update siteInitiatives function for site ${siteSlug}`);
}


function commonCollaborationSetInitiatives(isOnChange)
{
    var items = siteInitiatives(window['site']);

    for (var item of items) {
        if ($('#initiatives\\[initiatives----' + item + '\\]').is(':checked')) {
            $('#primary_initiative option[value="primary_initiative----' + item + '"]').prop('disabled', false);
        } else {
            if (isOnChange && ($('#primary_initiative').val() == ('primary_initiative----' + item))) {
                $('#primary_initiative option').prop('selected', false);
                $('#primary_initiative').val('');
            }
            $('#primary_initiative option[value="primary_initiative----' + item + '"]').prop('disabled', true);
        }
    }

    reinitializeSelect2($('#primary_initiative')); // update the changes to the initiatives in the select2
}

function onReadyModuleCommonCollaboration() {
    $('.webform input[name*="collaboration\\["]').change(function(e, is_self_triggered) {
        if (is_self_triggered) return;

        if ($(this).attr('name') == 'collaboration[collaboration----no_collaboration]') {
            $('.webform input[name*="collaboration\\["]').not('input[name*="collaboration\\[collaboration----no_collaboration\\]"]').prop('checked', false);
        } else {
            // We issue a change event on no_collaboration to fire the collaboration_names change handler
            $('input[name*="collaboration\\[collaboration----no_collaboration\\]"]').prop('checked', false).trigger("change", true /* self-triggered */);
        }
    });
    $('.webform input[name*="initiatives\\["]').change(function() {
        commonCollaborationSetInitiatives(true);
    });
    commonCollaborationSetInitiatives(false);

    // Put Disciplines into a multi-column list
    $('.common_collaboration .webform_element_disciplines .col-xs-10').wrapInner('<div class="multi-column"><div></div></div>');
}

function onReadyModuleCommonCollaborationSelectAll() {
    $('.webform .webform_element_disciplines .apply').append(
        '<br><span class="btn btn-default btn-xs select-all" data-for=".webform_element_disciplines .col-xs-10 input:checkbox">Select all</span>'
    );
    $('.webform .webform_element_initiatives .apply').append(
        '<br><span class="btn btn-default btn-xs select-all" data-for=".webform_element_initiatives .col-xs-10 input:checkbox">Select all</span>'
    );
    $('.btn.select-all').click(selectAllChange);
}

function selectAllChange() {
    let jThis = $(this);
    let jAll = $(jThis.data('for'));
    if (jThis.text() == 'Select all') {
        jThis.text('Select none');
        jAll.prop('checked', true).parent();
    } else {
        jThis.text('Select all');
        jAll.prop('checked', false).parent();
    }
    // Manually handle change events for speed
    $('#disciplines\\[disciplines----other\\]').change();
    commonCollaborationSetInitiatives(true);
    $('#initiatives\\[initiatives----socio_ecological_observatory\\]').change();
    $('#initiatives\\[initiatives----socio_ecological_modeling_prediction\\]').change();
}

function setupModule(module_slug, is_subform) {
    if (module_slug === 'background') { onReadyModuleBackground() }
    if (module_slug === 'participants' && is_subform) { onReadyModuleParticipantsSubform() }
    if (module_slug === 'participants') { onReadyModuleParticipants() }
    if (module_slug === 'funding') { onReadyModuleFunding() }
    if (module_slug === 'publications') { onReadyModulePublications() }
    if (module_slug === 'ip') { onReadyModuleIP() }
    if (module_slug === 'collaborators') { onReadyModuleCollaborators() }
    if (module_slug === 'outreach') { onReadyModuleOutreach() }
    if (module_slug === 'qualtrics') { onReadyModuleQualtrics() }
    if (module_slug === 'proposals') { onReadyModuleProposals() }
    if ($('.common_collaboration').length) { onReadyModuleCommonCollaboration() }

    $('.webform .webform_element_type_checkboxes:not(.single) > label').append('<br><span class="apply">(select all that apply)</span>');

    Util.setupLabelPositionAdjuster(); // Must be after module loaders, as they may change label contents
}

/**********************************************************
 * OnReady Handler
 **********************************************************/

$(document).ready(function() {
    if (typeof window['route_module_slug'] !== 'undefined') {
        let module_slug = window['route_module_slug'];
        let is_subform = module_slug == window['route_subform_element'];
        preserveUnsavedState(() => setupModule(module_slug, is_subform));
    }
});

}
